<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="Department" v-if="Title == 'Department'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Directorate" v-if="Title == 'Directorate'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Employee" v-if="Title == 'Employee'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="User" v-if="Title == 'User' || Title == 'Admin'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Division" v-if="Title == 'Division'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Section" v-if="Title == 'Section'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Superior" v-if="Title == 'Superior'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Warning_Letter" v-if="Title == 'Warning_Letter'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Company" v-if="Title == 'Company'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Unit" v-if="Title == 'Unit'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Position" v-if="Title == 'Position'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Functional" v-if="Title == 'Functional'" />
    <IndexBase @auth="onAuth($event)" action="Index" controller="Org_Unit" v-if="Title == 'Org_Unit'" />
    <IndexBase @auth="onAuth($event)" action="IndexAll" controller="Appraisal" v-if="Title == 'Komite'" />
    <IndexBase @auth="onAuth($event)" action="Index?title=Appraisal" controller="Employee" v-if="Title == 'Appraisal'" />

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                        Upload File {{ Title == 'Warning_Letter' ? 'SP' : Title == 'Department' ? 'Department & Division' :
                            Title == 'Org_Unit' ? 'Organization Unit' : Title }}
                    </div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <div class="field grid" style="margin-left:15px;">
                <Message severity="warn" v-html="this.messageError">
                </Message>
            </div>
            <div class="field grid" style="margin-left:15px;">
                <div class="col-3 md-3">
                    <FormField v-model="Attachments" fieldClass="col-12">
                        <CustomFileUpload :multiple="false" :showUploadButton="false" :showCancelButton="false"
                            :customUpload="false" @select="onFileSelect" ref="attachment" />
                    </FormField>
                </div>
                <div class="col-2 md-2" style="margin-top:20px;">
                    <Button icon="pi pi-chevron-left" label="Back"
                        class="p-button p-component p-button-rounded p-button-primary mr-2 mb-2" @click="gotoList" />
                    <Button label="Tampilkan Data" icon="pi pi-eye"
                        class="p-button p-component p-button-rounded p-button-success mr-2 mb-2" @click="showFile()"
                        @select="onFileSelect" />
                </div>
                <div class="col-7 md-7">
                    <Panel :header="$t('download_supporting_data')">
                        <div class="field grid">
                            <div class="col-2 md-2">
                                <a v-bind:href="UrlTemplate" target="_blank"
                                    class="p-button p-component p-button-rounded p-button-secondary mr-2 mb-2">
                                    <span class="pi pi-download p-button-icon p-button-icon-left"></span>TEMPLATE
                                </a>
                            </div>
                        </div>
                        <div class="field grid" v-if="this.Title == 'Superior'">
                            <div class="col-2 md-2">
                                <Button icon="pi pi-user" label="Daftar Karyawan"
                                    class="p-button p-component p-button-rounded p-button-help mr-2 mb-2"
                                    @click="toEmployee" />
                            </div>
                        </div>
                        <div class="field grid" v-if="this.Title == 'Komite'">
                            <div class="col-2 md-2">
                                <a v-bind:href="QuestionTemplate" target="_blank"
                                    class="p-button p-component p-button-rounded p-button-help mr-2 mb-2">
                                    <span class="pi pi-download p-button-icon p-button-icon-left"></span>Question
                                </a>
                            </div>
                        </div>
                        <div class="field grid" v-if="this.Title == 'Komite'">
                            <div class="col-2 md-2">
                                <Button type="button"
                                    class="p-button p-component p-button-rounded p-button-warning mr-2 mb-2"
                                    label="Employee" @click="exportEmployee()" icon="pi pi-external-link" />
                            </div>
                        </div>
                        <div class="field grid" v-if="this.Title == 'Komite'">
                            <div class="col-2 md-2">
                                <Button type="button"
                                    class="p-button p-component p-button-rounded p-button-danger mr-2 mb-2"
                                    label="Penilaian" @click="exportAppraisal()" icon="pi pi-external-link" />
                            </div>
                        </div>
                        <div class="field grid" v-if="this.Title == 'Komite'">
                            <div class="col-2 md-2">
                                <Button type="button" class="p-button p-component p-button-rounded p-button-info mr-2 mb-2"
                                    label="NIK" @click="exportNIK()" icon="pi pi-external-link" />
                            </div>
                        </div>
                    </Panel>
                </div>
            </div>
            <div v-if="this.htmlBody && this.Title != 'Superior' && this.Title != 'User' && this.Title != 'Admin' && this.Title != 'Employee'
                && this.Title != 'Warning_Letter' && this.Title != 'Komite' && this.Title != 'Appraisal' && this.Title != 'Org_Unit'"
                class="alert">
                <b>{{ this.$store.getters.getLanguage == 'id' ? ('Catatan : Kode ' + this.Title) : ('Note : ' + this.Title +
                    ' Code') }} {{ this.$t('note.upload') }}</b>
            </div>
            <br />
            <div v-if="this.htmlBody" v-html="this.htmlBody" id="divBody"></div>
            <br>
            <div v-if="this.header">
                <Button label="Import" icon="pi pi-upload"
                    class="p-button p-component p-button-rounded p-button-warning mr-2 mb-2" @click="importFile()"
                    @select="onFileSelect" />
            </div>

            <div v-html="this.excelTbl.content" v-if="this.excelTbl" v-show="false" />
        </template>
    </Card>

    <Dialog header="Confirmation" v-model:visible="showModal" :closeOnEscape="false" :closable="false" :modal="true">
        <div class="confirmation-content">
            <i class="pi pi-check-circle mr-3" style="font-size: 2rem" />
            <span><b>Upload Data Saved Successfully</b></span>
        </div>
        <template #footer>
            <div style="text-align:center">
                <Button label="OK" @click="gotoList"
                    class="p-button p-component p-button-rounded p-button-success mr-2 mb-2" autofocus />
            </div>
        </template>
    </Dialog>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "UploadData",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            stateKey: 'state-helper-uploaddata-' + this.$store.getters.getUsername,
            podFiles: [],
            url: this.$API_URL + "Upload/",
            urlNIK: this.$API_URL + "Upload/getApprovedNIK/",
            urlEmployee: this.$API_URL + "Upload/getEmployeeList/",
            urlAppraisal: this.$API_URL + "Upload/getAppraisalList/",
            messageError: null,
            showModal: false,
            userid: "",
            header: null,
            htmlBody: null,
            excelTbl: null
        }
    },
    methods: {
        onAuth(event) {
            if (!event.canUpload)
                this.$router.push({ name: 'Denied' });
        },
        onFileSelect(event) {
            this.podFiles = event.files;
        },
        showFile() {
            this.messageError = null;

            var self = this;
            if (this.podFiles.length == 0)
                this.showError('Error Upload Data', "Must have at least one file");
            else {
                this.$emit('block-ui');
                var self = this;
                var data = new FormData();

                for (var i = 0; i < this.podFiles.length; i++) {
                    data.append("file", this.podFiles[i], this.podFiles[i].name);
                }

                data.append("modul", JSON.stringify(self.Title));

                this.$axios.put(this.url, data,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        timeout: 7000000
                    }).then((response) => {
                        if (response.data.success) {
                            this.$emit('unblock-ui');
                            self.header = response.data.data.header;
                            self.htmlBody = response.data.data.htmlBody;
                        }
                        else {
                            this.$emit('unblock-ui');
                            this.messageError = response.data.message;
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });

                this.podFiles = [];
                this.$refs.attachment.remove(0);
            }
        },
        importFile() {
            this.$emit('block-ui');
            var self = this;

            this.$axios.post(this.url + this.Title, this.header,
                {
                    timeout: 7000000,
                    signal: AbortSignal.timeout(7000000)
                }).then((response) => {
                    this.$emit('unblock-ui');

                    if (response.data == '')
                        self.showError('Error Saving Data', response.data.message);
                    else if (!response.data.success)
                        self.showError('Error Saving Data', response.data.message);
                    else if (response.data.success)
                        this.showModal = true;
                })
                .catch(function (error) {
                    this.$emit('unblock-ui');
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 10000 });
        },
        gotoList() {
            if (this.Title == 'Department')
                this.$router.push({ name: "DepartmentIndex" });
            else if (this.Title == 'Directorate')
                this.$router.push({ name: "DirectorateIndex" });
            else if (this.Title == 'Employee')
                this.$router.push({ name: "EmployeeIndex" });
            else if (this.Title == 'User' || this.Title == 'Admin')
                this.$router.push({ name: "UserIndex" });
            else if (this.Title == 'Division')
                this.$router.push({ name: "DivisionIndex" });
            else if (this.Title == 'Section')
                this.$router.push({ name: "SectionIndex" });
            else if (this.Title == 'Superior')
                this.$router.push({ name: "SuperiorIndex" });
            else if (this.Title == 'Komite')
                this.$router.push({ name: "AppraisalIndexAllIndex" });
            else if (this.Title == 'Warning_Letter')
                this.$router.push({ name: "Warning_LetterIndex" });
            else if (this.Title == 'Company')
                this.$router.push({ name: "CompanyIndex" });
            else if (this.Title == 'Unit')
                this.$router.push({ name: "UnitIndex" });
            else if (this.Title == 'Position')
                this.$router.push({ name: "PositionIndex" });
            else if (this.Title == 'Functional')
                this.$router.push({ name: "FunctionalIndex" });
            else if (this.Title == 'Appraisal')
                this.$router.push({ name: "AppraisalIndexAllIndex" });
            else if (this.Title == 'Org_Unit')
                this.$router.push({ name: "Org_UnitIndex" });
            else
                this.$router.push("/");
        },
        toEmployee() {
            this.$router.push({ path: "/Employee/Index" });
        },
        tableToExcelMultipleSheet() {
            var uri = 'data:application/vnd.ms-excel;base64,'
                , html_start = `<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">`
                , template_ExcelWorksheet = `<x:ExcelWorksheet><x:Name>{SheetName}</x:Name><x:WorksheetSource HRef="sheet{SheetIndex}.htm"/></x:ExcelWorksheet>`
                , template_ListWorksheet = `<o:File HRef="sheet{SheetIndex}.htm"/>`
                , template_HTMLWorksheet = `
------=_NextPart_dummy
Content-Location: sheet{SheetIndex}.htm
Content-Type: text/html; charset=windows-1252

` + html_start + `
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
  <link id="Main-File" rel="Main-File" href="../WorkBook.htm">
  <link rel="File-List" href="filelist.xml">
</head>
<body>{SheetContent}</body>
</html>`
                , template_WorkBook = `MIME-Version: 1.0
X-Document-Type: Workbook
Content-Type: multipart/related; boundary="----=_NextPart_dummy"

------=_NextPart_dummy
Content-Location: WorkBook.htm
Content-Type: text/html; charset=windows-1252

` + html_start + `
<head>
<meta name="Excel Workbook Frameset">
<meta http-equiv="Content-Type" content="text/html; charset=windows-1252">
<link rel="File-List" href="filelist.xml">
<!--[if gte mso 9]><xml>
 <x:ExcelWorkbook>
  <x:ExcelWorksheets>{ExcelWorksheets}</x:ExcelWorksheets>
  <x:ActiveSheet>0</x:ActiveSheet>
 </x:ExcelWorkbook>
</xml><![endif]-->
</head>
<frameset>
  <frame src="sheet0.htm" name="frSheet">
  <noframes><body><p>This page uses frames, but your browser does not support them.</p></body></noframes>
</frameset>
</html>
{HTMLWorksheets}
Content-Location: filelist.xml
Content-Type: text/xml; charset="utf-8"

<xml xmlns:o="urn:schemas-microsoft-com:office:office">
  <o:MainFile HRef="../WorkBook.htm"/>
  {ListWorksheets}
  <o:File HRef="filelist.xml"/>
</xml>
------=_NextPart_dummy--
`
                , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
                , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }

            var context_WorkBook = {
                ExcelWorksheets: ''
                , HTMLWorksheets: ''
                , ListWorksheets: ''
            };

            var tables = document.getElementsByClassName('Appraisal');
            for (var SheetIndex = 0; SheetIndex < tables.length; SheetIndex++) {
                var e = tables[SheetIndex];

                var SheetName = e.getAttribute('data-SheetName');
                if (SheetName.trim() === '') {
                    SheetName = 'Sheet' + SheetIndex;
                }
                context_WorkBook.ExcelWorksheets += format(template_ExcelWorksheet, {
                    SheetIndex: SheetIndex
                    , SheetName: SheetName
                });
                context_WorkBook.HTMLWorksheets += format(template_HTMLWorksheet, {
                    SheetIndex: SheetIndex
                    , SheetContent: e.outerHTML
                });
                context_WorkBook.ListWorksheets += format(template_ListWorksheet, {
                    SheetIndex: SheetIndex
                });
            };

            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = "ListAssessed_" + currentDate;
            var link = document.createElement("A");
            link.href = uri + base64(format(template_WorkBook, context_WorkBook));
            link.download = fileName || 'Workbook.xls';
            link.click();
        },
        tableToExcel() {
            var uri = "data:application/vnd.ms-excel;base64,",
                template =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
                base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                },
                format = function (s, c) {
                    return s.replace(/{(\w+)}/g, function (m, p) {
                        return c[p];
                    });
                };
            var ctx = {
                worksheet: "Default" || "Worksheet",
                table: this.excelTbl.header + this.excelTbl.content,
            };
            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = this.excelTbl.title + "_" + currentDate;
            const link = document.createElement("a");
            link.href = uri + base64(format(template, ctx));
            link.download = fileName;
            link.click();
        },
        exportNIK() {
            this.$emit('block-ui');
            this.$axios.get(this.urlNIK)
                .then((response) => {
                    if (response.data.success) {
                        this.excelTbl = {
                            header: response.data.data.header,
                            content: response.data.data.content,
                            title: response.data.data.title,
                        };

                        this.tableToExcel();
                    }

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                })
        },
        exportEmployee() {
            this.$emit('block-ui');
            this.$axios.get(this.urlEmployee)
                .then((response) => {
                    this.excelTbl = {
                        header: response.data.data.header,
                        content: response.data.data.content,
                        title: response.data.data.title,
                    };

                    this.tableToExcel();

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                })
        },
        exportAppraisal() {
            this.$emit('block-ui');
            this.$axios.get(this.urlAppraisal)
                .then((response) => {
                    if (response.data.success) {
                        this.excelTbl = {
                            header: response.data.data.header,
                            content: response.data.data.content,
                            title: response.data.data.title,
                        };
                    }

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                })
                .finally(() => {
                    this.tableToExcelMultipleSheet();
                });
        }
    },
    mounted() {
        if (this.$route.params.title != 'Department' && this.$route.params.title != 'Directorate' && this.$route.params.title != 'Employee'
            && this.$route.params.title != 'User' && this.$route.params.title != 'Division' && this.$route.params.title != 'Section'
            && this.$route.params.title != 'Superior' && this.$route.params.title != 'Komite' && this.$route.params.title != 'Warning_Letter'
            && this.$route.params.title != 'Company' && this.$route.params.title != 'Unit' && this.$route.params.title != 'Position'
            && this.$route.params.title != 'Functional' && this.$route.params.title != 'Admin' && this.$route.params.title != 'Appraisal'
            && this.$route.params.title != 'Org_Unit')
            this.$router.push("/");

        this.$emit('unblock-ui');
        this.$showToast();
    },
    computed: {
        Title() {
            return this.$route.params.title;
        },
        UrlTemplate() {
            if (this.$route.params.title == 'Department')
                return this.$API_URL.replace('/api', '') + 'PES/DepartmentTemplate.xlsx';
            else if (this.$route.params.title == 'Directorate')
                return this.$API_URL.replace('/api', '') + 'PES/DirektoratTemplate.xlsx';
            else if (this.$route.params.title == 'Employee')
                return this.$API_URL.replace('/api', '') + 'PES/EmployeeTemplate.xlsx';
            else if (this.$route.params.title == 'Admin')
                return this.$API_URL.replace('/api', '') + 'PES/AdminTemplate.xlsx';
            else if (this.$route.params.title == 'User')
                return this.$API_URL.replace('/api', '') + 'PES/UserTemplate.xlsx';
            else if (this.$route.params.title == 'Division')
                return this.$API_URL.replace('/api', '') + 'PES/DivisionTemplate.xlsx';
            else if (this.$route.params.title == 'Section')
                return this.$API_URL.replace('/api', '') + 'PES/SectionTemplate.xlsx';
            else if (this.$route.params.title == 'Superior')
                return this.$API_URL.replace('/api', '') + 'PES/SuperiorTemplate.xlsx';
            else if (this.$route.params.title == 'Komite')
                return this.$API_URL.replace('/api', '') + 'PES/KomiteTemplate.xlsx';
            else if (this.$route.params.title == 'Warning_Letter')
                return this.$API_URL.replace('/api', '') + 'PES/SPTemplate.xlsx';
            else if (this.$route.params.title == 'Company')
                return this.$API_URL.replace('/api', '') + 'PES/CompanyTemplate.xlsx';
            else if (this.$route.params.title == 'Unit')
                return this.$API_URL.replace('/api', '') + 'PES/OUTemplate.xlsx';
            else if (this.$route.params.title == 'Position')
                return this.$API_URL.replace('/api', '') + 'PES/PositionTemplate.xlsx';
            else if (this.$route.params.title == 'Functional')
                return this.$API_URL.replace('/api', '') + 'PES/FunctionalTemplate.xlsx';
            else if (this.$route.params.title == 'Appraisal')
                return this.$API_URL.replace('/api', '') + 'PES/AppraisalTemplate.xlsx';
            else if (this.$route.params.title == 'Org_Unit')
                return this.$API_URL.replace('/api', '') + 'PES/Org_UnitTemplate.xlsx';
            else
                return '';
        },
        QuestionTemplate() {
            return this.$API_URL.replace('/api', '') + 'PES/Form Performance Appraisal.xlsx';
        }
    }
}
</script>
<style>
#divBody table {
    width: 100%;
    /* word-wrap: break-word;
    table-layout: fixed; */
}

#divBody thead {
    font-weight: bold;
}

#divBody table,
#divBody th,
#divBody td {
    border: 1px solid black;
    border-collapse: collapse;
    text-align: left;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 11pt;
    padding: 5px;
}

.alert {
    color: #3c763d;
    padding: 15px;
    background-color: #dff0d8;
    border-color: #d6e9c6;
    border: 1px solid transparent;
    border-radius: 4px;
}

.p-panel-content {
    display: flex;
}
</style>